import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleMapsProvider } from '@ubilabs/google-maps-react-hooks';
import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { MemoryRouter, Routes, Route } from 'react-router-dom';

import { MapPage } from './pages/Map.page';
import { SearchPage } from './pages/Search.page';

const VITE_GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

const MAP_OPTIONS: google.maps.MapOptions = {
  panControl: false,
  mapTypeControl: false,
  scrollwheel: true,
  streetViewControl: false,
  zoomControl: true,
  cameraControl: false,
  clickableIcons: false,
  mapId: '9cd0d8c32769dc0f31516bfd', // old map id 'b6dd273551bda709',
  minZoom: 3,
};

const queryClient = new QueryClient();

export function App() {
  const { i18n } = useTranslation();

  document.body.dir = i18n.dir();

  const [mapContainer, setMapContainer] = useState();
  const mapRef = useCallback((node: any) => {
    if (node) setMapContainer(node);
  }, []);

  return (
    <GoogleMapsProvider
      googleMapsAPIKey={VITE_GOOGLE_API_KEY}
      mapOptions={MAP_OPTIONS}
      mapContainer={mapContainer}
      libraries={['places', 'geometry', 'marker', 'geocoding']}
    >
      <QueryClientProvider client={queryClient}>
        <MemoryRouter>
          <Routes>
            <Route path="/" element={<SearchPage />} />
            <Route path="/map" element={<MapPage mapRef={mapRef} />} />
          </Routes>
        </MemoryRouter>
      </QueryClientProvider>
    </GoogleMapsProvider>
  );
}
